import React from "react";

import { useParams } from "react-router-dom";
import ObjectAnalytics from "../components/ObjectAnalytics";

const Analytics: React.FC = () => {
  const { projectId } = useParams();
  return (
    <ObjectAnalytics projectId={projectId} tableName="Analytics"/>
  )
}

export default Analytics;